var map = {
	"./2D.svg": 5621,
	"./ATM.svg": 1249,
	"./Bus.svg": 911,
	"./Calendar.svg": 745,
	"./Calendar_Week.svg": 4832,
	"./Car.svg": 8607,
	"./Drop-Off.svg": 300,
	"./Escalator.svg": 9453,
	"./Lift.svg": 2288,
	"./MRT.svg": 9182,
	"./Nursing.svg": 6507,
	"./Parking.svg": 4921,
	"./SideBar-left.svg": 9005,
	"./SideBar-right.svg": 7632,
	"./Toilet.svg": 5020,
	"./arrow-left-long-active.svg": 4386,
	"./arrow-left-long-inactive.svg": 1599,
	"./arrow-left-slider2.svg": 5220,
	"./arrow-left-slider3.svg": 9941,
	"./arrow-left-small.svg": 8882,
	"./arrow-left.svg": 5648,
	"./arrow-right-long-active.svg": 4337,
	"./arrow-right-long-inactive.svg": 6228,
	"./arrow-right-slider2.svg": 8295,
	"./arrow-right-slider3.svg": 9318,
	"./arrow-right-small.svg": 2237,
	"./arrow-right-white-large.svg": 853,
	"./arrow-right-white.svg": 5199,
	"./arrow-right.svg": 6415,
	"./bus-active.svg": 494,
	"./car-active.svg": 9694,
	"./concierge.svg": 5708,
	"./detail-poi-close.svg": 3404,
	"./detail-poi-escalator.svg": 9068,
	"./detail-poi-lift.svg": 2183,
	"./detail-poi-location.svg": 9741,
	"./fb.svg": 1167,
	"./footer-logo.svg": 3250,
	"./instagram.svg": 5373,
	"./map-pin.svg": 5789,
	"./mrt-active.svg": 4149,
	"./parking-active.svg": 4340,
	"./refresh.svg": 2304,
	"./search.svg": 4343,
	"./select-file.svg": 934,
	"./switch.svg": 935,
	"./tag.svg": 8197,
	"./tiktok.svg": 5301,
	"./wifi.svg": 5460
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;